import {writable} from 'svelte/store';

// Sort orders the search page offers (and accepts from a URL)
export const SEARCH_ORDERS = ['relevance', 'distance_asc', 'distance_desc', 'elevation_desc', 'duration_asc', 'created_desc'];

const initState = {
    query: undefined,
    queryDisplay: undefined,

    isSearching: true,

    ridesData: [],
    ridesLoadedFromMap: true,

    totalCount: 0,

    availableFilters: [],
    // Slider bounds of the current query or area, kept while its filters change
    filterBounds: null,
    selectedFilters: {
        rideTypes: null,
        levels: null,
        distance: null,
        duration: null,
        mine: null
    },
    order: 'relevance',

    visibleRideIds: [],
    // The user moved the map away from the searched area
    canSearchArea: false,

    highlightedRideId: undefined,
    selectedRideId: undefined,
    // Route picked in the suggestions: the results are that route, not a place
    pickedRideId: undefined
};

function SearchStore(state = initState) {
    const {
        subscribe,
        // set,
        update
    } = writable(
        state
    );

    function updateState(data) {
        Object.entries(data)
            .forEach(([dataName, newData]) => {
                update((storeState) => {
                    storeState[dataName] = newData;

                    return storeState;
                });
            });
    }

    return {
        subscribe,
        get state() {
            return state;
        },
        get query() {
            return state.query;
        },
        set query(query) {
            updateState({query});
        },
        get queryDisplay() {
            return state.queryDisplay;
        },
        set queryDisplay(queryDisplay) {
            updateState({queryDisplay});
        },
        get isSearching() {
            return state.isSearching;
        },
        set isSearching(isSearching) {
            updateState({isSearching});
        },
        get ridesData() {
            return state.ridesData;
        },
        set ridesData(ridesData) {
            updateState({ridesData: ridesData || []});
        },
        get ridesLoadedFromMap() {
            return state.ridesLoadedFromMap;
        },
        set ridesLoadedFromMap(ridesLoadedFromMap) {
            updateState({ridesLoadedFromMap});
        },
        get totalCount() {
            return state.totalCount;
        },
        set totalCount(totalCount) {
            updateState({totalCount});
        },
        get filterBounds() {
            return state.filterBounds;
        },
        set filterBounds(filterBounds) {
            updateState({filterBounds});
        },
        get order() {
            return state.order;
        },
        set order(order) {
            updateState({order});
        },
        get canSearchArea() {
            return state.canSearchArea;
        },
        set canSearchArea(canSearchArea) {
            updateState({canSearchArea});
        },
        get pickedRideId() {
            return state.pickedRideId;
        },
        set pickedRideId(pickedRideId) {
            updateState({pickedRideId});
        },
        get selectedRideId() {
            return state.selectedRideId;
        },
        set selectedRideId(selectedRideId) {
            updateState({selectedRideId});
        },
        get availableFilters() {
            return state.availableFilters;
        },
        set availableFilters(availableFilters) {
            updateState({availableFilters});
        },
        get selectedFilters() {
            return state.selectedFilters;
        },
        set selectedFilters(selectedFilters) {
            updateState({selectedFilters});
        },
        get hasFilters() {
            if (!state.selectedFilters) {
                return false;
            }

            return Object.entries(state.selectedFilters)
                .some(([, filterValue]) => !!filterValue);
        },
        get visibleRideIds() {
            return state.visibleRideIds;
        },
        set visibleRideIds(visibleRideIds) {
            updateState({visibleRideIds});
        },
        get highlightedRideId() {
            return state.highlightedRideId;
        },
        set highlightedRideId(highlightedRideId) {
            updateState({highlightedRideId});
        }
    };
}

// export function getSearchState() {
//     return SearchStore().state || {};
// }

// export function CreateSearchStore(onStateUpdate) {
//     const store = SearchStore();
//
//     const unsubscribe = store.subscribe((newState) => {
//         if (typeof onStateUpdate === 'function') {
//             onStateUpdate(newState);
//         }
//     });
//
//     return {
//         store,
//         subscribe: store.subscribe,
//         unsubscribe
//     };
// }

export const searchStore = SearchStore();
